module.exports = __webpack_public_path__ + "static/media/flag-cr.7eade229.webp";